import { SITE_URL } from "../../../config";

// generate the legend
export const generateLegend = (d3, interpolater, minReach, maxReach) => {
  const legendSvg = d3.select('svg.legend');

  legendSvg.selectAll('*').remove();

  const gradient = legendSvg
    .append('defs')
    .append('linearGradient')
    .attr('id', 'gradient-blues')
    .attr('x1', '0%')
    .attr('y1', '0%')
    .attr('x2', '100%')
    .attr('y2', '0%');

  gradient
    .append('stop')
    .attr('offset', '0%')
    .attr('stop-color', interpolater(0));
  gradient
    .append('stop')
    .attr('offset', '100%')
    .attr('stop-color', interpolater(1));

  const gradientRect = legendSvg
    .append('rect')
    .attr('width', 200)
    .attr('height', 20)
    .attr('x', 0)
    .attr('y', 10)
    .style('fill', 'url(#gradient-blues)');

  const minText = legendSvg
    .append('text')
    .attr('class', 'legend-label')
    .attr('x', 0)
    .attr('y', 50)
    .text(maxReach > 0 ? formatNumber(minReach) : '');

  const maxText = legendSvg
    .append('text')
    .attr('class', 'legend-label')
    .attr('text-anchor', 'end')
    .attr('y', 50)
    .text(maxReach > 0 ? formatNumber(maxReach) : '');

  // Adjust the width dynamically
  setTimeout(() => {
    const bbox = legendSvg.node().getBBox();
    const newWidth = bbox.width + 10;
    const newHeight = bbox.height + 10;

    legendSvg.attr('width', newWidth).attr('height', newHeight);
    
    maxText.attr('x', newWidth);
    gradientRect.attr('width', newWidth);
  }, 0);
};


export const generateDMABorders = (g, dma, topojson, path) => {
  g.append('path')
    .datum(topojson.mesh(dma, dma.objects.dma_shp))
    .attr('id', 'dma-borders')
    .attr('d', path)
    .attr('fill', 'none')
    .attr('stroke', '#666');
};

export const generateHoverEffects = (
  d3,
  paths,
  path,
  colorScale,
  normalizeScale,
  handleDMAClick,
  selectedDMA
) => {
  const tooltipHover = d3.select('#dmatooltip-hover');
  const tooltipStatic = d3.select('#dmatooltip');
  
  const mapContainer = document.querySelector('.ms-map').parentElement;

  paths
    .enter()
    .append('path')
    .merge(paths)
    .attr('d', path)
    .on('mousemove', function (event, d) {
      const prop = d.properties;
      if (prop.dma_name === 'National') {
        return;
      }

      const reach = prop['reach'] ? formatNumber(prop['reach']) : 0;
      const mapContainerRect = mapContainer.getBoundingClientRect();
      const mouseX = event.clientX - mapContainerRect.left;
      const mouseY = event.clientY - mapContainerRect.top;

      tooltipHover
        .html(
          `
            <strong>${prop.dma_name}</strong>
            <hr/>
            <p style="display: flex; justify-content: space-between; margin: 0;">
            <strong style="margin-right: 1rem;">Reach:</strong> <span>${reach}</span>
            </p>
          `
        )
        .style('visibility', 'visible')
        .style('left', `${mouseX + 10}px`)
        .style('top', `${mouseY + 10}px`);

      tooltipStatic
        .html(
          `
            <strong>${prop.dma_name}</strong>
            <hr/>
            <p style="display: flex; justify-content: space-between; margin: 0;">
            <strong style="margin-right: 1rem;">Reach:</strong> <span>${reach}</span>
            </p>
          `
        )
        .style('visibility', 'visible');
    })
    .on('click', handleDMAClick)
    .on('mouseleave', () => {
      tooltipHover.style('visibility', 'hidden');
    })
    .attr('opacity', 0.9)
    .attr('fill', (d) => {
      let reach = d.properties['reach'] ? d.properties['reach'] : 0;
      const color = colorScale(normalizeScale(reach));
      return color == 'rgb(0, 0, 0)' ? 'white' : color;
    })
    .attr('class', (d) => {
      return d.properties.dma_name.replace(/,/g, '') === selectedDMA
        ? 'selectedDMA'
        : '';
    });
};

export const formatNumber = (number, asCurrency = false) => {
  if (isNaN(number)) {
    return '';
  }

  const userLocale = 'en-US';

  const options = asCurrency
    ? { style: 'currency', currency: 'USD' }
    : {};

  const formatter = new Intl.NumberFormat(userLocale, options);

  return formatter.format(number);
};


export const camelCaseToTitleCase = (str) => {
  if (str === str.toUpperCase()) {
    return str; // Don't format abbreviations
  }

  str = str.charAt(0).toUpperCase() + str.slice(1);
  str = str.replace(/([A-Z])/g, ' $1').trim();

  return str;
};

export const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const makeMSRequest = async (url, method, body) => {
  const endpoint = SITE_URL + url;
  const response = await fetch(endpoint, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  return response.json();
}
